module.exports = __webpack_public_path__ + "img/tentaculo.11f203e4.png";